import { createContext } from 'react';
import './App.css';
import Main from './components/main/Main';
import {config} from "./data/config"
import useDarkMode from "./hooks/UseDarkMode"

export const darkModeContext = createContext()

function App() {

  const [theme , toggleTheme] = useDarkMode();

  console.log(theme)

  return (
    <div className={`${theme == "light" ? undefined : "dark"}`}>
      <darkModeContext.Provider value={{
        theme,
        toggleTheme
      }}>
         <Main toggleTheme={toggleTheme} />
      </darkModeContext.Provider>
    </div>
  );
}

export default App;
